import Service from '../Service';
import { ResponseErrorBody } from '../../types';
import Request from '../Request';
import { addFingerprintToRequest } from './utils';

export async function confirmIp(token: string) {
  const request = await addFingerprintToRequest(
    new Request(`/api/auth/ip/${token}/confirm`).setMethod('GET')
  );
  const service = new Service<any, ResponseErrorBody>(request);
  return await service.send();
}
